import React from 'react';
import { makeStyles } from '@fluentui/react-components';
import AdminSectionNavigation from './AdminSectionNavigation';

const useStyles = makeStyles({
  page: {
    width: '100%',
    maxWidth: '1800px',
    minHeight: 0,
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto',
    overflow: 'hidden',
  },
  content: {
    flex: '1 1 auto',
    minHeight: 0,
    padding: '20px 40px 24px',
    overflowY: 'auto',
  },
});

type AdminPageLayoutProps = React.PropsWithChildren;

const AdminPageLayout: React.FC<AdminPageLayoutProps> = ({ children }) => {
  const styles = useStyles();

  return (
    <div className={styles.page}>
      <AdminSectionNavigation />
      {children}
    </div>
  );
};

export const AdminPageContent: React.FC<AdminPageLayoutProps> = ({ children }) => {
  const styles = useStyles();

  return <div className={styles.content}>{children}</div>;
};

export default AdminPageLayout;